/* ======================================================================== */
/* 34. lazyLoad */
/* ======================================================================== */
function lazyLoad($scope = document, $elements = $document.find('.lazy')) {

	var $images = $elements.find('img[data-src]:not(img.lazy-bg):not(img.swiper-lazy)');
	var $backgrounds = $scope.find('.lazy-bg[data-src]:not(.swiper-lazy)');
	var imagesInstance =  $images.Lazy({
		threshold: 1000,
		chainable: false,
		afterLoad: function (el) {

			$(el).parent().css({
				'padding-bottom': '',
				'width': '',
				'height': '',
				'animation-name': 'none',
				'background-color': 'initial'
			});

			setTimeout(function () {
				new Grid();
			}, 300);

		}

	});
	var backgroundsInstance =  $backgrounds.Lazy({
		threshold: 1000,
		chainable: false
	});

	// destroy lazy instances on new page transition
	window.$window.one('arts/barba/transition/init', () => {
		imagesInstance.destroy();
		backgroundsInstance.destroy();
	});

}
